module.exports = ".info{width:100%;clear:both;cursor:pointer;font-size:14px;display:block}.info .body{position:relative}.scrollable-settings{overflow:auto}.material-buttons{z-index:5}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/personal-info/personal-info.component.scss
// module id = 714
// module chunks = 0